import React from 'react';
import { Box, Container } from '@mui/material';
import { layoutPaddingY } from './layoutSpacing';

const CheckoutLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#ffffff' }}>
      <Container maxWidth="md" sx={{ py: layoutPaddingY }}>
        {children}
      </Container>
    </Box>
  );
};

export default CheckoutLayout;
